import React from "react";

export default function Chat({ fill, width, height }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 2.31244C0.5 1.96436 0.638281 1.63054 0.884422 1.38441C1.13056 1.13827 1.4644 1 1.8125 1H6.40625C6.75434 1 7.08818 1.13827 7.33432 1.38441C7.58046 1.63054 7.71874 1.96436 7.71874 2.31244V4.93733C7.71874 5.28541 7.58046 5.61924 7.33432 5.86537C7.08818 6.1115 6.75434 6.24977 6.40625 6.24977H5.09375L3.125 8.21844V6.24977H1.8125C1.4644 6.24977 1.13056 6.1115 0.884422 5.86537C0.638281 5.61924 0.5 5.28541 0.5 4.93733V2.31244Z"
        fill={fill}
      />
      <path
        d="M9.03157 3.62549V4.93793C9.03157 5.63409 8.75501 6.30174 8.26273 6.79401C7.77045 7.28627 7.10277 7.56282 6.40658 7.56282H5.63745L4.47852 8.72236C4.66227 8.82014 4.87161 8.87526 5.09408 8.87526H6.40658L8.37533 10.8439V8.87526H9.68782C10.0359 8.87526 10.3698 8.73699 10.6159 8.49085C10.862 8.24472 11.0003 7.9109 11.0003 7.56282V4.93793C11.0003 4.58985 10.862 4.25602 10.6159 4.00989C10.3698 3.76376 10.0359 3.62549 9.68782 3.62549H9.03157Z"
        fill={fill}
      />
    </svg>
  );
}
